"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var H1_1 = require("./H1");
Object.defineProperty(exports, "H1", { enumerable: true, get: function () { return H1_1.default; } });
var H2_1 = require("./H2");
Object.defineProperty(exports, "H2", { enumerable: true, get: function () { return H2_1.default; } });
var H3_1 = require("./H3");
Object.defineProperty(exports, "H3", { enumerable: true, get: function () { return H3_1.default; } });
var H4_1 = require("./H4");
Object.defineProperty(exports, "H4", { enumerable: true, get: function () { return H4_1.default; } });
var Title_1 = require("./Title");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return Title_1.default; } });
//# sourceMappingURL=index.js.map